import { useFilter } from './Filter';
import * as List from './List';
import { useKind } from './useKind';
import { useSearch } from './useSearchScroll';

export const Search = {
  useFilter,
  List,
  useKind,
  useSearch,
};
